<template>
  <v-col>
    <v-card>
      <v-card-title>
        <p class="pl-6">{{ $tc("main-nav.mentors", 2) }}</p>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          :label="$t('common.search')"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        @click:row="goToMentor"
        :headers="headers"
        :items="mentor_diaries"
        :loading="loading"
        item-key="id"
        class="elevation-1 row-pointer"
        :footer-props="footer"
        :loading-text="$t('common.loading')"
        :no-results-text="$t('common.no_results')"
        :options.sync="options"
        :server-items-length="$store.state.user.totalCount"
        dense
      >
        <template v-slot:no-data>
          {{ $t("common.no_results") }}
        </template>
      </v-data-table>
    </v-card>
  </v-col>
</template>

<script>
import { createNamespacedHelpers } from "vuex"

import { FETCH } from "@/store/action-types"
import TableMixin from "@/mixins/TableMixin"

const { mapActions } = createNamespacedHelpers("user")

export default {
  name: "MentorsPage",
  mixins: [TableMixin],
  data() {
    return {
      expanded: [],
      params: { role: "MENTOR" },
    }
  },
  computed: {
    current_user() {
      return this.$store.state.user.profile
    },
    mentor_diaries() {
      return this.$store.state.user.data
    },

    headers() {
      return [
        {
          value: "first_name",
          text: this.$tc("user.first_name", 1),
          width: "24%",
        },
        {
          value: "last_name",
          text: this.$tc("user.last_name", 1),
          width: "24%",
        },
      ]
    },
  },

  methods: {
    goToMentor(e) {
      this.$router.push({ name: "mentor_diary", params: { user_id: e.id } })
    },
    ...mapActions([FETCH]),
  },
}
</script>
<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
